// Haak voor de scanner-testharnas.
//
// Draait de app binnen het testharnas-iframe (herkenbaar aan ?wmsTest=1), dan
// worden twee dingen geregeld vóórdat React iets doet:
//
//   1. Elk verzoek krijgt de header X-WMS-Testmodus. De server zet het verzoek
//      daarmee op de testrol, die op productietabellen alleen mag lezen
//      (migratie 0227). De vlag zit hier en niet in client.ts, omdat niet alle
//      aanroepen door api() lopen — sommige roepen fetch rechtstreeks aan.
//   2. Elk verzoek wordt naar het bovenliggende venster gemeld voor het
//      netwerkpaneel. Dat gebeurt binnen het iframe, dus ook het allereerste
//      verzoek bij het opstarten staat erin.
//
// Buiten het harnas doet dit bestand niets: geen parameter, geen haak.

export const TESTMODUS_HEADER = "X-WMS-Testmodus";

/** Draait deze app binnen het testharnas? Ook waar na een herlading. */
export function inHarnas(): boolean {
  if (window.self === window.top) return false;
  try { return sessionStorage.getItem("wms_harnas") !== null; } catch { return false; }
}

export function installeerHarnessHaak(): void {
  // ALLEEN binnen het iframe van het harnas.
  //
  // sessionStorage hoort bij het tabblad en het domein, niet bij het document.
  // Het harnas en de app erin delen allebei, dus een vlag die het iframe zet is
  // ook zichtbaar voor de gewone app in datzelfde tabblad. Zonder deze regel
  // praat je desktoppagina na één bezoek aan het harnas tegen de zandbak, en
  // dat overleeft een ververs.
  if (window.self === window.top) {
    // Opruimen: een vlag uit een eerdere sessie mag hier niets meer doen.
    try { sessionStorage.removeItem("wms_harnas"); } catch { /* private mode */ }
    return;
  }

  const params = new URLSearchParams(window.location.search);

  // De vlag komt uit de URL, maar wordt in sessionStorage bewaard. Zonder dat
  // verliest de app de testmodus zodra hij zelf navigeert of herlaadt — en
  // schrijft hij ineens naar productie. sessionStorage hoort bij dit ene
  // iframe-tabblad, dus het lekt niet naar een gewone sessie.
  if (params.get("wmsTest") === "1") {
    try { sessionStorage.setItem("wms_harnas", params.get("veilig") === "0" ? "0" : "1"); } catch { /* private mode */ }
  }

  let vlag: string | null = null;
  try { vlag = sessionStorage.getItem("wms_harnas"); } catch { /* private mode */ }
  if (vlag === null) return;

  const testmodus = vlag !== "0";
  const origineel = window.fetch.bind(window);
  let teller = 0;

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const id = ++teller;
    const url = typeof input === "string" ? input
      : input instanceof URL ? input.toString() : input.url;
    const methode = (init?.method ?? (input instanceof Request ? input.method : "GET")).toUpperCase();

    let opties = init;
    if (testmodus && url.startsWith("/api/")) {
      const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
      headers.set(TESTMODUS_HEADER, "1");
      opties = { ...init, headers };
    }

    const start = performance.now();
    const melden = (extra: Record<string, unknown>) => {
      try {
        window.parent.postMessage({
          bron: "wms-harness", id, url, methode,
          payload: typeof init?.body === "string" ? init.body : undefined,
          duur_ms: Math.round(performance.now() - start),
          testmodus, ...extra,
        }, window.location.origin);
      } catch { /* geen ouder, of andere origin */ }
    };

    try {
      const res = await origineel(input, opties);
      // Kopie, zodat de app de body gewoon zelf kan lezen.
      let tekst: string | undefined;
      try { tekst = await res.clone().text(); } catch { /* stream niet te klonen */ }
      melden({ status: res.status, ok: res.ok, antwoord: tekst?.slice(0, 4000) });
      return res;
    } catch (e) {
      melden({ status: 0, ok: false, antwoord: e instanceof Error ? e.message : "netwerkfout" });
      throw e;
    }
  };
}
